import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Logo extends Component {
  render() {
    const { t } = this.context;
    const { url, type, size } = this.props;

    return (
      <div className="logos-container__wrapper__item">
        <div className={`type-${type}`}>
          <img src={url} alt="Logo" className="logos-container__wrapper__item__img" style={size || {}} />
        </div>
        <p className="banner-container__header__size">
          {t('BANNERS.SIZE')}: {size ? size.width.replace('px', '') : t('COMMON.DEFAULT')}
          {size ? 'X' : ''}
          {size ? size.height.replace('px', '') : ''}
        </p>
      </div>
    );
  }
}

Logo.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default Logo;



// WEBPACK FOOTER //
// ./src/app/main/logos/components/logo.js